var CryptoJS = require("crypto-js");
import asyncStorage from "@react-native-async-storage/async-storage";

const storage = {
  get: async () =>
    await asyncStorage.getItem("@auth").then((result) => {
      if (result) {
        var decryptedValue = CryptoJS.AES.decrypt(
          result,
          "hr12j-2sde3_F3rxs-j3dld"
        );
        var originalValue = decryptedValue.toString(CryptoJS.enc.Utf8);

        return JSON.parse(originalValue);
      } else {
        return null;
      }
    }),

  set: async (value: AuthDataT) => {
    const strValue = JSON.stringify(value);

    var encryptedValue = CryptoJS.AES.encrypt(
      strValue,
      "hr12j-2sde3_F3rxs-j3dld"
    ).toString();

    await asyncStorage.setItem("@auth", encryptedValue);
  },

  remove: async () => await asyncStorage.removeItem("@auth"),
};

export default storage;
